import { Icon, Typography } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { RubricRatingSchema } from '@scale/shared/pipelinev3/genai';
import { RubricRating } from '@scale/shared/types/params/textcollection';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface RubricRatingsBuilderProps {
  name: string;
  hint?: string;
  existingValue?: Array<RubricRating>;
  updateProperty: (arg: Array<RubricRating> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const RubricRatingsBuilder: React.FC<RubricRatingsBuilderProps> = ({
  name,
  hint,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const rubricRatings = existingValue || [
    {
      label:
        'No, there is some subjectivity in assessing if the response meets this criteria, but more than 75% of people would arrive at the same assessment.',
      value: 'subjective',
    },
    {
      label:
        'Yes, this criteria is specific, well-defined, and we can clearly determine if the response meets the criteria.',
      value: 'objective',
    },
  ];
  return (
    <div className="flex flex-col gap-2">
      <Typography.Subtitle3>{name}</Typography.Subtitle3>
      {hint && <Typography.Paragraph3>{hint}</Typography.Paragraph3>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={rubricRatings}
        setElements={updateProperty}
        getKey={rubricRating => JSON.stringify(rubricRating)}
        getTitle={rubricRating => rubricRating.label || '<New Rating>'}
        getSchema={_ => RubricRatingSchema}
      />
      <Icon
        hasBackground
        icon={['fas', 'plus']}
        onClick={() =>
          updateProperty([
            ...rubricRatings,
            {
              value: '',
              label: '',
              color: '',
              score: 0,
            },
          ])
        }
        size="md"
        variant="primary"
      />
    </div>
  );
};

export default RubricRatingsBuilder;
